import { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import type { NFDAuctionAndPrice } from 'api/api-client'

export type CountdownTimer = {
  days: number
  hours: number
  minutes: number
  seconds: number
}

export default function useAuctionCountdown(auction: NFDAuctionAndPrice): {
  timer: CountdownTimer
  price: number
} {
  const countdownEnd = +dayjs(auction.auctionInfo.endTime).add(5, 'second')

  const [countdown, setCountdown] = useState(countdownEnd - new Date().getTime())

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(countdownEnd - new Date().getTime())
    }, 1000)

    return () => clearInterval(interval)
  }, [countdownEnd])

  const getTimeRemaining = (countdown: number) => {
    const days = Math.floor(countdown / (1000 * 60 * 60 * 24))
    const hours = Math.floor((countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((countdown % (1000 * 60)) / 1000)

    return { days, hours, minutes, seconds }
  }

  const getPrice = (countdown: number) => {
    const minutes = Math.floor(countdown / (1000 * 60))
    const changePerMinute = auction.changePerMinute
    const floorPrice = auction.auctionInfo.floorPrice

    return floorPrice + Number(changePerMinute) * (minutes + 1)
  }

  return {
    timer: getTimeRemaining(countdown),
    price: getPrice(countdown)
  }
}
